import { WORKER_URL } from '../config.js';
import { getSession } from './auth_utils.js';
import { fetchCache } from './fetchCache.js';

const PRIVATE_CHARACTERS_URL = `${WORKER_URL}/private/characters`;

// Private character payloads use `id`, but legacy bucket rows may carry `character_id`.
// Normalize to a single `id` so sprite URLs and IndexedDB keyPaths resolve consistently.
export const normalizePrivateCharacter = (character) => {
  const resolvedId = character?.id ?? character?.character_id;
  if (resolvedId == null) return null;
  return { ...character, id: String(resolvedId), private: true, style: character.style ?? 'anime' };
};

export const findPrivateCharacterById = (characters, characterId) =>
  (characters || []).find(c => String(c.id) === String(characterId)) || null;

export const clearPrivateCharactersCache = () => {
  fetchCache.invalidate(PRIVATE_CHARACTERS_URL);
};

export const fetchPrivateCharacters = async () => {
  const session = await getSession();
  if (!session?.access_token) throw new Error('Authentication required for private characters');

  const result = await fetchCache.fetchJSON(PRIVATE_CHARACTERS_URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`
    }
  });

  if (!result.success) throw new Error('Failed to fetch private characters');

  return (result.characters || []).map(normalizePrivateCharacter).filter(Boolean);
};

export const fetchPrivateCharacterById = async (characterId) => {
  const characters = await fetchPrivateCharacters();
  return findPrivateCharacterById(characters, characterId);
};
